// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.ConfirmLandlordBusinessTypeWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType } from '@zg-rentals/ts-rent-payment-client';

import type { ConfirmLandlordBusinessTypeWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Args {
  postData: ConfirmLandlordBusinessTypeWebApiRequestDto;
}

export type ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Options = UseMutationOptions<
  void,
  unknown,
  ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Args
>;

/**
 * Confirm whether the landlord collects rent as an individual or a company
 */
export const useConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType = ({
  httpClient,
  ...options
}: Omit<ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Args) =>
      ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType(args.postData, httpClient),
  });
};
